import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarDate = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.598 16.833q.614.267 1.406.266.788 0 1.396-.266a2.34 2.34 0 0 0 .958-.728q.348-.465.348-1.055a1.75 1.75 0 0 0-.205-.841 1.9 1.9 0 0 0-.547-.64 1.7 1.7 0 0 0-.768-.33v-.05q.55-.123.899-.571.351-.451.351-1.04 0-.562-.32-1.002-.316-.44-.865-.692a2.9 2.9 0 0 0-1.247-.256q-.707 0-1.257.256a2.13 2.13 0 0 0-.867.692q-.315.44-.312 1.001-.003.59.34 1.04.35.45.91.573v.05a1.76 1.76 0 0 0-.774.33q-.345.255-.547.639a1.75 1.75 0 0 0-.199.841 1.7 1.7 0 0 0 .34 1.055q.35.462.96.728m2.116-.888a1.7 1.7 0 0 1-.71.139q-.412 0-.717-.142a1.1 1.1 0 0 1-.47-.394 1.03 1.03 0 0 1-.162-.59 1.08 1.08 0 0 1 .17-.614q.178-.27.483-.423.306-.152.696-.152.387 0 .689.152.305.153.48.423.177.266.18.614-.003.335-.17.59-.167.256-.469.397m-.12-3.31q-.256.136-.59.136-.338 0-.6-.135a1.06 1.06 0 0 1-.409-.377 1.03 1.03 0 0 1-.142-.557q-.003-.312.139-.547a.96.96 0 0 1 .405-.366 1.34 1.34 0 0 1 .607-.131q.338 0 .597.131a.96.96 0 0 1 .404.366q.145.234.15.547-.005.315-.153.557-.15.242-.409.377"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.75 3a.75.75 0 0 0-1.5 0H6a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4h-.25a.75.75 0 0 0-1.5 0zm8.5 3V4.5h-8.5V6a.75.75 0 0 1-1.5 0V4.5H6A2.5 2.5 0 0 0 3.5 7v11A2.5 2.5 0 0 0 6 20.5h12a2.5 2.5 0 0 0 2.5-2.5V7A2.5 2.5 0 0 0 18 4.5h-.25V6a.75.75 0 0 1-1.5 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendarDate;
